<template>
  <div class="card p-0 m-0 col-12">
    <!-- <div class="card-header fs-5 fw-bold pt-2 pb-0 pl-3">
      <p class="m-0 fs-5">Select Jail Time</p>
    </div> -->
    <div class="card-body fs-4">
      <p class="fs-4 p-0 mb-3 fw-bold">
        Count {{ charge?.CountNumber }}:
        
        {{ charge?.SectionNumber }}
        {{ charge?.Name }}
      </p>
      <div class="d-flex w-100">
        <div class="d-flex flex-column p-0">
          <p class="fs-4 p-0 m-0">
             Minimum Jail Term: 
    
            {{
              minJail
            }} days
          </p>
          <p class="fs-4 p-0 m-0">
             Maximum Jail Term: 
    
            {{
             maxJail
            }} days
          </p>
        </div>
        
        <!-- <div class="d-flex flex-column col-6 p-0">
          <div class="d-flex align-items-center ">
            <input type="checkbox" v-model="charge.ProbationGranted" class="mr-3" id="probationGranted" @input="setGranted">
            <label for="probationGranted" class="fs-4 p-0 m-0">Probation Granted</label>
          </div>
         
        </div> -->
      </div>
      
      <div class="d-flex flex-column">
        <label for="selectedJailTime" class="fw-bold fs-4 mt-4">Set Jail Term</label>
        <div class="d-flex">
          <input
            type="number"
            class="form-control-lg"
            id="selectedJailTime"
            v-model="selectedJailTime"
      
          />
          <span class="d-flex align-items-center justify-content-center ml-5 fw-bold"
            >Days
          </span>
        </div>
      </div>
      <div class="d-flex align-items-center flex-column mt-3">
        <button class="btn btn-primary" :disabled="!validTermLength" @click="setJailTerm">Set Jail Term</button>
        <p  v-if="!validTermLength" class="fs-5 fw-bold">Invalid Term Length</p>
      </div>
      
    </div>
  </div>
</template>
<script>
import { max } from "lodash";
import SC from "../../../components/utils/sharedComponent.vue";
export default {
  name: "JailTime",
  props: ["charges", "selectedCharge", "caseId", "probationEligibility"],
  components: { SC },
  data() {
    return {
      selectedJailTime: 0,
      // charge: {}
    };
  },
  computed: {
    minJail() {
      let minJailDays = this.charge?.LowerTermLength * this.charge?.LowerTermUnits;
      if (this.charge?.ProbationGranted) {
        minJailDays = this.charge?.MinimumProbationJailTimeLength * this.charge?.MinimumProbationJailTimeUnits;
      }
      if (this.attachedSubstitution) {
        minJailDays = this.attachedSubstitution.LowerTermLength * this.attachedSubstitution.LowerTermUnits;
      }
      return minJailDays;
    },
    maxJail() {
      let maxJailDays = this.charge?.UpperTermLength * this.charge?.UpperTermUnits;
      if (this.charge?.ProbationGranted) {
        maxJailDays = this.charge?.MaximumProbationJailTimeLength * this.charge?.MaximumProbationJailTimeUnits;
      }
      if (this.attachedSubstitution) {
        maxJailDays = this.attachedSubstitution.UpperTermLength * this.attachedSubstitution.UpperTermUnits;
      }
      return maxJailDays;
    },
    validTermLength(){
      return this.selectedJailTime >= this.minJail && this.selectedJailTime <= this.maxJail;
    },
    charge(){
      return this.charges[this.selectedCharge]
    },
    attachedSubstitution() {
      const attachedSubstitutionIndex = this.charges.findIndex(chg => {
        return chg.CrimeTypeId == 2 && chg.ChargeStatus == 0 && chg.CountNumber == this.charge.CountNumber
      })
      return this.charges[attachedSubstitutionIndex]
    }
  },
  mounted() {
    // console.log(this.probationEligibility)
    // this.charge = this.charges[this.selectedCharge];
    this.selectedJailTime = this.charge?.ProbationJailTimeDays || this.charge?.newExposureObject.determinate;
  },
  methods: {
    setGranted(val) {
      
      SC.postChargeFieldValue(
        this.charge?.Id,
        "ProbationGranted",
        this.charge?.ProbationGranted,
        localStorage.getItem("user_token"),
        this.caseId
      ).then((result) => {
        this.$emit("onCalc");
      });
    },
    setJailTerm(){
      this.charge.ProbationJailTimeDays = this.selectedJailTime;
      SC.postChargeFieldValue(
        this.charge?.Id,
        "ProbationJailTimeDays",
        this.charge?.ProbationJailTimeDays,
        localStorage.getItem("user_token"),
        this.caseId
      ).then((result) => {
        this.$emit("onCalc");
        this.$emit("close")
      });
    },
  },
  // watch: {
  //   selectedJailTime: async function (val, oldVal) {
  //     // console.log(val, oldVal);
  //     const chg = this.charge;
  //     // console.log(chg);
  //     // console.log(chg);
  //     if (val < this.minJail) {
  //       // console.log("BAD");
  //       this.selectedJailTime = this.minJail;
  //     } else if (val > this.maxJail) {
  //       // console.log("BAD");
  //       this.selectedJailTime = this.maxJail;
  //     }

  //     if (val === null || val === "" || val === undefined) {
  //       val = this.minJail;
  //       this.selectedJailTime = val;
  //     }
  //     // chg.ProbationJailTimeDays = val;
  //     // console.log(val);
      
  //   },
  // },
};
</script>
